/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Table_ActionInputs */

const en_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const de_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion`)
};

const fr_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

const es_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción`)
};

const it_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azione`)
};

const nl_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actie`)
};

const pl_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akcja`)
};

const fi_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toiminto`)
};

const da_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handling`)
};

const sv_settings_table_action = /** @type {(inputs: Settings_Table_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åtgärd`)
};

/**
* | output |
* | --- |
* | "Action" |
*
* @param {Settings_Table_ActionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_table_action = /** @type {((inputs?: Settings_Table_ActionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Table_ActionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_table_action(inputs)
	if (locale === "fr") return fr_settings_table_action(inputs)
	if (locale === "es") return es_settings_table_action(inputs)
	if (locale === "it") return it_settings_table_action(inputs)
	if (locale === "nl") return nl_settings_table_action(inputs)
	if (locale === "pl") return pl_settings_table_action(inputs)
	if (locale === "fi") return fi_settings_table_action(inputs)
	if (locale === "da") return da_settings_table_action(inputs)
	if (locale === "sv") return sv_settings_table_action(inputs)
	return en_settings_table_action(inputs)
});